module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#twitter",
      toString: function () {
        return this.url;
      }
    }